module.exports = __webpack_public_path__ + "3d8979aacc8461e31d69b74e58bc37bc.jpg";